import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../Shared/Button';

const CTASection = ({
  title,
  description,
  buttonText,
  buttonVariant = 'secondary',
  imageSrc,
  imageAlt = 'cta-image',
  backgroundImage,
  overlayImage,
  className = '',
  contentClassName = '',
  imageClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  buttonClassName = 'w-full md:w-50',
  onClick,
}) => {
  return (
    <div
      className={`relative flex flex-col md:flex-row items-center md:justify-between px-6 py-12 md:px-28 md:py-0 gap-12 md:min-h-[439px] ${className}`}
    >
      {backgroundImage && (
        <img
          src={backgroundImage}
          alt="background"
          className="absolute w-full h-full md:min-h-[439px] top-0 left-0 right-0 z-10"
        />
      )}
      {overlayImage && (
        <img
          src={overlayImage}
          alt="overlay"
          className="absolute w-full h-full md:min-h-[439px] top-0 left-0 right-0 z-10"
        />
      )}
      {imageSrc && (
        <img
          src={imageSrc}
          alt={imageAlt}
          className={`w-full md:w-[545px] md:min-h-[335px] z-20 ${imageClassName}`}
        />
      )}
      <div
        className={`z-20 flex flex-col items-start gap-5 flex-1 flex-shrink-0 text-center md:text-left ${contentClassName}`}
      >
        <h2
          className={`text-2xl md:text-[32px] leading-[36px] md:leading-[45px] font-semibold text-white ${titleClassName}`}
        >
          {title}
        </h2>
        <p
          className={`text-base leading-6 font-normal font-mark-ot text-white ${descriptionClassName}`}
        >
          {description}
        </p>
        <Button
          variant={buttonVariant}
          size="medium"
          className={buttonClassName}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

CTASection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonVariant: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  backgroundImage: PropTypes.string,
  overlayImage: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func,
};

export default CTASection;
